import { InvoiceEventType } from '@features/invoices/enums/invoiceEventType'

export const DEMO_INVOICE_EVENT_TYPE_TO_TRANSLATION_KEY: Partial<Record<InvoiceEventType, string>> = {
  [InvoiceEventType.DeliveryEmailSent]: 'external_invoices.view.sidebar.timeline.status.delivery.email.sent',
  [InvoiceEventType.DeliveryInhouseEinvoiceSent]:
    'external_invoices.view.sidebar.timeline.status.delivery.inhouse.einvoice.sent',
  [InvoiceEventType.DocumentCreated]: 'external_invoices.view.sidebar.timeline.status.document.created',
  [InvoiceEventType.DocumentPdfDownloaded]: 'external_invoices.view.sidebar.timeline.status.document.pdf.downloaded',
}
